/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/resetPassword'
import { Route as AcceptInviteRouteImport } from './routes/acceptInvite'
import { Route as MainRouteImport } from './routes/_main'
import { Route as UserRouteRouteImport } from './routes/user/route'
import { Route as MainIndexRouteImport } from './routes/_main/index'
import { Route as UserLoginRouteImport } from './routes/user/login'
import { Route as MainUsersRouteImport } from './routes/_main/users'
import { Route as MainMuserRouteImport } from './routes/_main/muser'
import { Route as MainLiveAlertsRouteImport } from './routes/_main/live-alerts'
import { Route as MainDashboardRouteImport } from './routes/_main/dashboard'
import { Route as MainAdminRouteImport } from './routes/_main/admin'
import { Route as MainSplatRouteImport } from './routes/_main/$'
import { Route as MainSettingsRouteRouteImport } from './routes/_main/settings/route'
import { Route as MainSettingsReportRouteImport } from './routes/_main/settings/report'
import { Route as MainSettingsMobileAppRouteImport } from './routes/_main/settings/mobileApp'
import { Route as MainSettingsGeofenceRouteImport } from './routes/_main/settings/geofence'
import { Route as MainSettingsBattery_lowRouteImport } from './routes/_main/settings/battery_low'
import { Route as MainSettingsAddressRouteImport } from './routes/_main/settings/address'
import { Route as MainPersonRedirectRouteImport } from './routes/_main/person/redirect'
import { Route as MainPersonListRouteImport } from './routes/_main/person/list'
import { Route as MainPersonAddRouteImport } from './routes/_main/person/add'
import { Route as MainPersonIdViewRouteImport } from './routes/_main/person/$id/view'
import { Route as MainPersonIdReportRouteImport } from './routes/_main/person/$id/report'
import { Route as MainPersonIdEditRouteImport } from './routes/_main/person/$id/edit'
import { Route as MainPersonIdDetailRouteImport } from './routes/_main/person/$id/detail'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/resetPassword',
  path: '/resetPassword',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/acceptInvite',
  path: '/acceptInvite',
  getParentRoute: () => rootRouteImport,
} as any)
const MainRoute = MainRouteImport.update({
  id: '/_main',
  getParentRoute: () => rootRouteImport,
} as any)
const UserRouteRoute = UserRouteRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => rootRouteImport,
} as any)
const MainIndexRoute = MainIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainRoute,
} as any)
const UserLoginRoute = UserLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UserRouteRoute,
} as any)
const MainUsersRoute = MainUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => MainRoute,
} as any)
const MainMuserRoute = MainMuserRouteImport.update({
  id: '/muser',
  path: '/muser',
  getParentRoute: () => MainRoute,
} as any)
const MainLiveAlertsRoute = MainLiveAlertsRouteImport.update({
  id: '/live-alerts',
  path: '/live-alerts',
  getParentRoute: () => MainRoute,
} as any)
const MainDashboardRoute = MainDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => MainRoute,
} as any)
const MainAdminRoute = MainAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => MainRoute,
} as any)
const MainSplatRoute = MainSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => MainRoute,
} as any)
const MainSettingsRouteRoute = MainSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => MainRoute,
} as any)
const MainSettingsReportRoute = MainSettingsReportRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => MainSettingsRouteRoute,
} as any)
const MainSettingsMobileAppRoute = MainSettingsMobileAppRouteImport.update({
  id: '/mobileApp',
  path: '/mobileApp',
  getParentRoute: () => MainSettingsRouteRoute,
} as any)
const MainSettingsGeofenceRoute = MainSettingsGeofenceRouteImport.update({
  id: '/geofence',
  path: '/geofence',
  getParentRoute: () => MainSettingsRouteRoute,
} as any)
const MainSettingsBattery_lowRoute = MainSettingsBattery_lowRouteImport.update({
  id: '/battery_low',
  path: '/battery_low',
  getParentRoute: () => MainSettingsRouteRoute,
} as any)
const MainSettingsAddressRoute = MainSettingsAddressRouteImport.update({
  id: '/address',
  path: '/address',
  getParentRoute: () => MainSettingsRouteRoute,
} as any)
const MainPersonRedirectRoute = MainPersonRedirectRouteImport.update({
  id: '/person/redirect',
  path: '/person/redirect',
  getParentRoute: () => MainRoute,
} as any)
const MainPersonListRoute = MainPersonListRouteImport.update({
  id: '/person/list',
  path: '/person/list',
  getParentRoute: () => MainRoute,
} as any)
const MainPersonAddRoute = MainPersonAddRouteImport.update({
  id: '/person/add',
  path: '/person/add',
  getParentRoute: () => MainRoute,
} as any)
const MainPersonIdViewRoute = MainPersonIdViewRouteImport.update({
  id: '/person/$id/view',
  path: '/person/$id/view',
  getParentRoute: () => MainRoute,
} as any)
const MainPersonIdReportRoute = MainPersonIdReportRouteImport.update({
  id: '/person/$id/report',
  path: '/person/$id/report',
  getParentRoute: () => MainRoute,
} as any)
const MainPersonIdEditRoute = MainPersonIdEditRouteImport.update({
  id: '/person/$id/edit',
  path: '/person/$id/edit',
  getParentRoute: () => MainRoute,
} as any)
const MainPersonIdDetailRoute = MainPersonIdDetailRouteImport.update({
  id: '/person/$id/detail',
  path: '/person/$id/detail',
  getParentRoute: () => MainRoute,
} as any)

export interface FileRoutesByFullPath {
  '/user': typeof UserRouteRouteWithChildren
  '/': typeof MainIndexRoute
  '/acceptInvite': typeof AcceptInviteRoute
  '/resetPassword': typeof ResetPasswordRoute
  '/settings': typeof MainSettingsRouteRouteWithChildren
  '/$': typeof MainSplatRoute
  '/admin': typeof MainAdminRoute
  '/dashboard': typeof MainDashboardRoute
  '/live-alerts': typeof MainLiveAlertsRoute
  '/muser': typeof MainMuserRoute
  '/users': typeof MainUsersRoute
  '/user/login': typeof UserLoginRoute
  '/person/add': typeof MainPersonAddRoute
  '/person/list': typeof MainPersonListRoute
  '/person/redirect': typeof MainPersonRedirectRoute
  '/settings/address': typeof MainSettingsAddressRoute
  '/settings/battery_low': typeof MainSettingsBattery_lowRoute
  '/settings/geofence': typeof MainSettingsGeofenceRoute
  '/settings/mobileApp': typeof MainSettingsMobileAppRoute
  '/settings/report': typeof MainSettingsReportRoute
  '/person/$id/detail': typeof MainPersonIdDetailRoute
  '/person/$id/edit': typeof MainPersonIdEditRoute
  '/person/$id/report': typeof MainPersonIdReportRoute
  '/person/$id/view': typeof MainPersonIdViewRoute
}
export interface FileRoutesByTo {
  '/user': typeof UserRouteRouteWithChildren
  '/acceptInvite': typeof AcceptInviteRoute
  '/resetPassword': typeof ResetPasswordRoute
  '/settings': typeof MainSettingsRouteRouteWithChildren
  '/$': typeof MainSplatRoute
  '/admin': typeof MainAdminRoute
  '/dashboard': typeof MainDashboardRoute
  '/live-alerts': typeof MainLiveAlertsRoute
  '/muser': typeof MainMuserRoute
  '/users': typeof MainUsersRoute
  '/user/login': typeof UserLoginRoute
  '/': typeof MainIndexRoute
  '/person/add': typeof MainPersonAddRoute
  '/person/list': typeof MainPersonListRoute
  '/person/redirect': typeof MainPersonRedirectRoute
  '/settings/address': typeof MainSettingsAddressRoute
  '/settings/battery_low': typeof MainSettingsBattery_lowRoute
  '/settings/geofence': typeof MainSettingsGeofenceRoute
  '/settings/mobileApp': typeof MainSettingsMobileAppRoute
  '/settings/report': typeof MainSettingsReportRoute
  '/person/$id/detail': typeof MainPersonIdDetailRoute
  '/person/$id/edit': typeof MainPersonIdEditRoute
  '/person/$id/report': typeof MainPersonIdReportRoute
  '/person/$id/view': typeof MainPersonIdViewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/user': typeof UserRouteRouteWithChildren
  '/_main': typeof MainRouteWithChildren
  '/acceptInvite': typeof AcceptInviteRoute
  '/resetPassword': typeof ResetPasswordRoute
  '/_main/settings': typeof MainSettingsRouteRouteWithChildren
  '/_main/$': typeof MainSplatRoute
  '/_main/admin': typeof MainAdminRoute
  '/_main/dashboard': typeof MainDashboardRoute
  '/_main/live-alerts': typeof MainLiveAlertsRoute
  '/_main/muser': typeof MainMuserRoute
  '/_main/users': typeof MainUsersRoute
  '/user/login': typeof UserLoginRoute
  '/_main/': typeof MainIndexRoute
  '/_main/person/add': typeof MainPersonAddRoute
  '/_main/person/list': typeof MainPersonListRoute
  '/_main/person/redirect': typeof MainPersonRedirectRoute
  '/_main/settings/address': typeof MainSettingsAddressRoute
  '/_main/settings/battery_low': typeof MainSettingsBattery_lowRoute
  '/_main/settings/geofence': typeof MainSettingsGeofenceRoute
  '/_main/settings/mobileApp': typeof MainSettingsMobileAppRoute
  '/_main/settings/report': typeof MainSettingsReportRoute
  '/_main/person/$id/detail': typeof MainPersonIdDetailRoute
  '/_main/person/$id/edit': typeof MainPersonIdEditRoute
  '/_main/person/$id/report': typeof MainPersonIdReportRoute
  '/_main/person/$id/view': typeof MainPersonIdViewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/user'
    | '/'
    | '/acceptInvite'
    | '/resetPassword'
    | '/settings'
    | '/$'
    | '/admin'
    | '/dashboard'
    | '/live-alerts'
    | '/muser'
    | '/users'
    | '/user/login'
    | '/person/add'
    | '/person/list'
    | '/person/redirect'
    | '/settings/address'
    | '/settings/battery_low'
    | '/settings/geofence'
    | '/settings/mobileApp'
    | '/settings/report'
    | '/person/$id/detail'
    | '/person/$id/edit'
    | '/person/$id/report'
    | '/person/$id/view'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/user'
    | '/acceptInvite'
    | '/resetPassword'
    | '/settings'
    | '/$'
    | '/admin'
    | '/dashboard'
    | '/live-alerts'
    | '/muser'
    | '/users'
    | '/user/login'
    | '/'
    | '/person/add'
    | '/person/list'
    | '/person/redirect'
    | '/settings/address'
    | '/settings/battery_low'
    | '/settings/geofence'
    | '/settings/mobileApp'
    | '/settings/report'
    | '/person/$id/detail'
    | '/person/$id/edit'
    | '/person/$id/report'
    | '/person/$id/view'
  id:
    | '__root__'
    | '/user'
    | '/_main'
    | '/acceptInvite'
    | '/resetPassword'
    | '/_main/settings'
    | '/_main/$'
    | '/_main/admin'
    | '/_main/dashboard'
    | '/_main/live-alerts'
    | '/_main/muser'
    | '/_main/users'
    | '/user/login'
    | '/_main/'
    | '/_main/person/add'
    | '/_main/person/list'
    | '/_main/person/redirect'
    | '/_main/settings/address'
    | '/_main/settings/battery_low'
    | '/_main/settings/geofence'
    | '/_main/settings/mobileApp'
    | '/_main/settings/report'
    | '/_main/person/$id/detail'
    | '/_main/person/$id/edit'
    | '/_main/person/$id/report'
    | '/_main/person/$id/view'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  UserRouteRoute: typeof UserRouteRouteWithChildren
  MainRoute: typeof MainRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/resetPassword': {
      id: '/resetPassword'
      path: '/resetPassword'
      fullPath: '/resetPassword'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/acceptInvite': {
      id: '/acceptInvite'
      path: '/acceptInvite'
      fullPath: '/acceptInvite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main': {
      id: '/_main'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MainRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user': {
      id: '/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof UserRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main/': {
      id: '/_main/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MainIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/user/login': {
      id: '/user/login'
      path: '/login'
      fullPath: '/user/login'
      preLoaderRoute: typeof UserLoginRouteImport
      parentRoute: typeof UserRouteRoute
    }
    '/_main/users': {
      id: '/_main/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof MainUsersRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/muser': {
      id: '/_main/muser'
      path: '/muser'
      fullPath: '/muser'
      preLoaderRoute: typeof MainMuserRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/live-alerts': {
      id: '/_main/live-alerts'
      path: '/live-alerts'
      fullPath: '/live-alerts'
      preLoaderRoute: typeof MainLiveAlertsRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard': {
      id: '/_main/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof MainDashboardRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/admin': {
      id: '/_main/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof MainAdminRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/$': {
      id: '/_main/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof MainSplatRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/settings': {
      id: '/_main/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof MainSettingsRouteRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/settings/report': {
      id: '/_main/settings/report'
      path: '/report'
      fullPath: '/settings/report'
      preLoaderRoute: typeof MainSettingsReportRouteImport
      parentRoute: typeof MainSettingsRouteRoute
    }
    '/_main/settings/mobileApp': {
      id: '/_main/settings/mobileApp'
      path: '/mobileApp'
      fullPath: '/settings/mobileApp'
      preLoaderRoute: typeof MainSettingsMobileAppRouteImport
      parentRoute: typeof MainSettingsRouteRoute
    }
    '/_main/settings/geofence': {
      id: '/_main/settings/geofence'
      path: '/geofence'
      fullPath: '/settings/geofence'
      preLoaderRoute: typeof MainSettingsGeofenceRouteImport
      parentRoute: typeof MainSettingsRouteRoute
    }
    '/_main/settings/battery_low': {
      id: '/_main/settings/battery_low'
      path: '/battery_low'
      fullPath: '/settings/battery_low'
      preLoaderRoute: typeof MainSettingsBattery_lowRouteImport
      parentRoute: typeof MainSettingsRouteRoute
    }
    '/_main/settings/address': {
      id: '/_main/settings/address'
      path: '/address'
      fullPath: '/settings/address'
      preLoaderRoute: typeof MainSettingsAddressRouteImport
      parentRoute: typeof MainSettingsRouteRoute
    }
    '/_main/person/redirect': {
      id: '/_main/person/redirect'
      path: '/person/redirect'
      fullPath: '/person/redirect'
      preLoaderRoute: typeof MainPersonRedirectRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/person/list': {
      id: '/_main/person/list'
      path: '/person/list'
      fullPath: '/person/list'
      preLoaderRoute: typeof MainPersonListRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/person/add': {
      id: '/_main/person/add'
      path: '/person/add'
      fullPath: '/person/add'
      preLoaderRoute: typeof MainPersonAddRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/person/$id/view': {
      id: '/_main/person/$id/view'
      path: '/person/$id/view'
      fullPath: '/person/$id/view'
      preLoaderRoute: typeof MainPersonIdViewRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/person/$id/report': {
      id: '/_main/person/$id/report'
      path: '/person/$id/report'
      fullPath: '/person/$id/report'
      preLoaderRoute: typeof MainPersonIdReportRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/person/$id/edit': {
      id: '/_main/person/$id/edit'
      path: '/person/$id/edit'
      fullPath: '/person/$id/edit'
      preLoaderRoute: typeof MainPersonIdEditRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/person/$id/detail': {
      id: '/_main/person/$id/detail'
      path: '/person/$id/detail'
      fullPath: '/person/$id/detail'
      preLoaderRoute: typeof MainPersonIdDetailRouteImport
      parentRoute: typeof MainRoute
    }
  }
}

interface UserRouteRouteChildren {
  UserLoginRoute: typeof UserLoginRoute
}

const UserRouteRouteChildren: UserRouteRouteChildren = {
  UserLoginRoute: UserLoginRoute,
}

const UserRouteRouteWithChildren = UserRouteRoute._addFileChildren(
  UserRouteRouteChildren,
)

interface MainSettingsRouteRouteChildren {
  MainSettingsAddressRoute: typeof MainSettingsAddressRoute
  MainSettingsBattery_lowRoute: typeof MainSettingsBattery_lowRoute
  MainSettingsGeofenceRoute: typeof MainSettingsGeofenceRoute
  MainSettingsMobileAppRoute: typeof MainSettingsMobileAppRoute
  MainSettingsReportRoute: typeof MainSettingsReportRoute
}

const MainSettingsRouteRouteChildren: MainSettingsRouteRouteChildren = {
  MainSettingsAddressRoute: MainSettingsAddressRoute,
  MainSettingsBattery_lowRoute: MainSettingsBattery_lowRoute,
  MainSettingsGeofenceRoute: MainSettingsGeofenceRoute,
  MainSettingsMobileAppRoute: MainSettingsMobileAppRoute,
  MainSettingsReportRoute: MainSettingsReportRoute,
}

const MainSettingsRouteRouteWithChildren =
  MainSettingsRouteRoute._addFileChildren(MainSettingsRouteRouteChildren)

interface MainRouteChildren {
  MainSettingsRouteRoute: typeof MainSettingsRouteRouteWithChildren
  MainSplatRoute: typeof MainSplatRoute
  MainAdminRoute: typeof MainAdminRoute
  MainDashboardRoute: typeof MainDashboardRoute
  MainLiveAlertsRoute: typeof MainLiveAlertsRoute
  MainMuserRoute: typeof MainMuserRoute
  MainUsersRoute: typeof MainUsersRoute
  MainIndexRoute: typeof MainIndexRoute
  MainPersonAddRoute: typeof MainPersonAddRoute
  MainPersonListRoute: typeof MainPersonListRoute
  MainPersonRedirectRoute: typeof MainPersonRedirectRoute
  MainPersonIdDetailRoute: typeof MainPersonIdDetailRoute
  MainPersonIdEditRoute: typeof MainPersonIdEditRoute
  MainPersonIdReportRoute: typeof MainPersonIdReportRoute
  MainPersonIdViewRoute: typeof MainPersonIdViewRoute
}

const MainRouteChildren: MainRouteChildren = {
  MainSettingsRouteRoute: MainSettingsRouteRouteWithChildren,
  MainSplatRoute: MainSplatRoute,
  MainAdminRoute: MainAdminRoute,
  MainDashboardRoute: MainDashboardRoute,
  MainLiveAlertsRoute: MainLiveAlertsRoute,
  MainMuserRoute: MainMuserRoute,
  MainUsersRoute: MainUsersRoute,
  MainIndexRoute: MainIndexRoute,
  MainPersonAddRoute: MainPersonAddRoute,
  MainPersonListRoute: MainPersonListRoute,
  MainPersonRedirectRoute: MainPersonRedirectRoute,
  MainPersonIdDetailRoute: MainPersonIdDetailRoute,
  MainPersonIdEditRoute: MainPersonIdEditRoute,
  MainPersonIdReportRoute: MainPersonIdReportRoute,
  MainPersonIdViewRoute: MainPersonIdViewRoute,
}

const MainRouteWithChildren = MainRoute._addFileChildren(MainRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  UserRouteRoute: UserRouteRouteWithChildren,
  MainRoute: MainRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
